import { makeObservable, observable, flow, computed } from "mobx";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import { Add, Download } from "@/components/icons/IconMap";

import BrowseRisksSchema from "@/areas/risks/schemas/BrowseRisksSchema";

import { RiskConstants } from "./RiskConstants";

export default class BrowseRisksStore {
  loading = true;
  pagination = null;
  risks = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      risks: observable,
      actions: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    const list = [];

    list.push({
      id: "risks:risk:report",
      label: "Report a Risk",
      onClick: () => this.parentStore.createRiskStore.show(),
      icon: Add,
      location: "primary",
      processing: this.parentStore.createRiskStore.processing,
      disabled: this.parentStore.createRiskStore.processing,
    });

    // list.push({
    //   id: "risks:export:pdf",
    //   label: "Export to PDF",
    //   onClick: () => {
    //     const link = document.createElement("a");
    //     link.href = AssetRoutes.forExportPdf(window.location.pathname + window.location.search);
    //     link.setAttribute("download", "Risks.pdf");
    //     document.body.appendChild(link);
    //     link.click();
    //     link.remove();
    //   },
    //   icon: FileDown,
    //   location: "secondary",
    // });

    return list;
  }

  *load(query, options) {
    const parseResult = BrowseRisksSchema.safeParse(query);
    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }

    try {
      this.loading = true;

      const existingQuery = query.query;

      const storedRiskTypes = JSON.parse(localStorage.getItem(RiskConstants.StateKeys.RiskTypes)) ?? [];
      const storedRiskTypeIds = storedRiskTypes.map((x) => x.id);
      const updatedQuery = { ...existingQuery, typeId: storedRiskTypeIds };

      const response = yield api.post(ApiRoutes.forRiskSearch(), { ...query, query: updatedQuery });
      this.risks = response.data.items;
      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
